import { Component, OnInit, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { PatientService } from '../../shared';

@Component({
  selector: 'app-code',
  templateUrl: './code.component.html',
  styleUrls: ['../style.component.css', './code.component.css']
})
export class CodeComponent implements OnInit {
  patid: any;
  welcome: any;
  modalRef: any;
  resdata: any;
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'modal-sm', backdrop: 'static' });
  }
  constructor(
    private patientservice: PatientService,
    private routerr: ActivatedRoute,
    private modalService: BsModalService,
    private nav: Router
  ) { }

  ngOnInit() {
    this.routerr.params.subscribe(params => {
      this.patid = params
      this.patientservice.changeNav(params['id'])
      this.patid = params['id']
      ////////console.log(this.patid);
    });
  }

  addpat(result) {
    //////console.log(this.patid);
    this.patientservice
      .getwelcome(this.patid, 'dob')
      .subscribe(
        data => {

          //////console.log(data);
          if (data.userInfo.status == "success") {

            this.nav.navigate([`/createnewpass/${this.patid}`])
          }
          else {
            this.resdata = "You have already registered";
            this.modalRef = this.modalService.show(result, { class: 'modal-sm', backdrop: 'static' });

          }
        }
      );

  }
}
